// extracted by mini-css-extract-plugin
export default {"signUp":"t7n9hrHmpA0KgUb6JFwl","referral":"ZjwDusKKGaTRdRSkMLY2","referralButton":"eaPa_ZF0REZaSEDOnups","focus-visible":"grV49Bbpk5X2QLktjlHf","noCode":"kY5gkKbSn_w_vAG1URBv"};